module.exports = __webpack_public_path__ + "static/media/image3.17901df7.png";